import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("bsp_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const setToken = (token) => localStorage.setItem("bsp_token", token);
export const clearToken = () => localStorage.removeItem("bsp_token");
export const getToken = () => localStorage.getItem("bsp_token");
